var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconTeleprompter = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 12,
    viewBox: "0 0 14 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.332 0H1.66536C0.932031 0 0.332031 0.6 0.332031 1.33333V10.6667C0.332031 11.4 0.932031 12 1.66536 12H12.332C13.0654 12 13.6654 11.4 13.6654 10.6667V1.33333C13.6654 0.6 13.0654 0 12.332 0ZM5.66536 9.33333H2.33203V8H5.66536V9.33333ZM5.66536 6.66667H2.33203V5.33333H5.66536V6.66667ZM5.66536 4H2.33203V2.66667H5.66536V4ZM8.8787 8L6.9987 6.10667L7.9387 5.16667L8.8787 6.11333L10.992 4L11.9387 4.94667L8.8787 8Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconTeleprompter);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon-teleprompter.a1ed4d2e818c301c1058e2e510395a21.svg";